// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pane_ajaBp {
  transition: box-shadow 0.2s;
}
.pane_ajaBp.pane-overlay_vxudj {
  padding: var( --size-padLarge );
  background-color: var( --color-white );
}
.pane_ajaBp.pane-overlay_vxudj:hover {
  box-shadow: none;
}
.pane_ajaBp.pane-navHeader_wiqfL {
  border: none;
  box-shadow: 0 8px 16px var( --color-shadowBase ),0 0px 1px var( --color-shadowBase );
  transition: width 0.4s;
  background-color: var( --color-brand800 );
}
.pane_ajaBp.pane-loginPane_kl1fh {
  border: 1px solid var( --color-base100 );
  padding: var( --size-padLarge );
  box-shadow: 0 8px 16px var( --color-shadowBase ),0 0px 1px var( --color-shadowBase );
  border-radius: 8px;
  background-color: var( --color-white );
}
.pane_ajaBp.pane-contentSection_MJg2_ {
  padding: 56px;
  background-color: transparent;
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
}
.pane_ajaBp.pane-contentSection_MJg2_.pane-contentBorder_e5jpf {
  padding: var( --size-padLarge ) var( --size-padLarge ) 24px;
  border-bottom: 1px solid var( --color-base200 );
}
.pane_ajaBp.pane-formHeader_VXjDE {
  padding: var( --size-padLarge );
  background-color: var( --color-white );
}
.pane_ajaBp.pane-formBody_o6CCf {
  padding: var( --size-padLarge );
  border-top: 1px solid var( --color-base050 );
  border-left: none;
  border-right: none;
  border-bottom: none;
  background-color: var( --color-base050 );
}
.pane_ajaBp.pane-dialogHeader_kCcQX {
  padding: var( --size-padLarge );
}
.pane_ajaBp.pane-dialogBody_oizj4 {
  width: 432px;
  padding: var( --size-padLarge );
  background-color: var( --color-white );
}
.pane_ajaBp.pane-dialogFooter_tP60i {
  padding: var( --size-padLarge );
}
.pane_ajaBp.pane-dialog_FXK8m {
  box-shadow: 0 8px 16px var( --color-shadowBase ),0 0px 1px var( --color-shadowBase );
  max-height: 80vh;
  border-radius: 8px;
  background-color: var( --color-white );
}
.pane_ajaBp.pane-loginWarning_zCQxl {
  border: 1px solid var( --color-danger100 );
  padding: var( --size-padMedium );
  margin-top: 16px;
  min-height: 0px;
  border-radius: 4px;
  margin-bottom: 0px;
  background-color: var( --color-shadowDanger );
}
.pane_ajaBp.pane-formGeoshape_pnmYI {
  padding: var( --size-padLarge );
  border-radius: 4px;
  background-color: var( --color-white );
}
.pane_ajaBp.pane-contentSection_MJg2_.pane-contentSectionWhite_djC5_ {
  padding: 56px;
  background-color: var( --color-white );
}
.pane_ajaBp.pane-card_kwSo4 {
  width: 100%;
  padding: var( --size-padLarge );
  box-shadow: 0 1px 3px var( --color-shadowBase );
  border-radius: var( --size-medium );
  background-color: var( --color-white );
}
.pane_ajaBp.pane-mobileTabPortal_DwbOX {
  height: 100%;
  background-color: var( --color-white );
}
.pane_ajaBp.pane-mobileActions_k1Y4_ {
  padding: var( --size-padXLarge ) var( --size-padLarge );
  background-color: var( --color-white );
  border-top-left-radius: var( --size-padLarge );
  border-top-right-radius: var( --size-padLarge );
}
.pane_ajaBp.pane-mobileTabsHeader_rYSYY {
  padding: var( --size-padLarge );
}
.pane_ajaBp.pane-mobileList_PBdHb {
  height: 100%;
  background-color: var( --color-base050 );
}
.pane_ajaBp.pane-mobileMapToggle_pGDYP {
  margin-left: var( --size-padMedium );
  padding-left: 12px;
  margin-right: var( --size-padMedium );
  padding-right: 40px;
}
.pane_ajaBp.pane-mobileItemHeader_svJKE {
  padding: var( --size-padLarge );
  background-color: var( --color-base050 );
}
.pane_ajaBp.pane-mobileItemBody_ePfFL {
  padding: var( --size-padLarge );
  background-color: var( --color-white );
}
.pane_ajaBp.pane-mobileList_PBdHb.pane-mobileListSettings_RbkVN {
  width: 100%;
  height: 100%;
  background-color: var( --color-base050 );
}
.pane_ajaBp.pane-mobileTabsHeader_rYSYY.pane-mobileDtrHeader_oFmAy {
  box-shadow: 0 1px 3px var( --color-shadowBase );
}
.pane_ajaBp.pane-mobileDtrContent_ZPAWi {
  padding: var( --size-padLarge );
}
.pane_ajaBp.pane-sidebar_Ipg9R {
  height: 100%;
  padding: var( --size-padLarge );
  box-shadow: 0 1px 3px var( --color-shadowBase );
}
.pane_ajaBp.pane-tablePagination_eESLq {
  height: 64px;
  box-shadow: 0 1px 3px var( --color-shadowBase );
  padding-left: var( --size-padMedium );
  padding-right: var( --size-padMedium );
  background-color: var( --color-white );
}
.pane_ajaBp.pane-editPageSizeOverlay_y0Xjn {
  width: 100vw;
  padding: var( --size-padLarge );
  max-width: 412px;
}
.pane_ajaBp.pane-rootHeader_bTPov {
  padding: var( --size-padMedium ) var( --size-padLarge ) var( --size-pad12 );
  z-index: 2;
  box-shadow: 0 1px 3px var( --color-shadowBase );
  min-height: 64px;
}
.pane_ajaBp.pane-dataCard_kDUPJ {
  padding: var( --size-padLarge );
}
.pane_ajaBp.pane-card_kwSo4.pane-graphContainer_Df06r {
  padding-left: 0px;
  padding-right: 0px;
}
.pane_ajaBp.pane-dialogHeader_kCcQX.pane-detailHeader_jBddk {
  padding-top: var( --size-padMedium );
  padding-bottom: var( --size-padMedium );
}
.pane_ajaBp.pane-collectionEditorListSection_g6tci {
  border-right: 3px solid var( --color-base200 );
}
.pane_ajaBp.pane-collectionEditorSelectionHeader_gciiA {
  padding: var( --size-padMedium );
  border-bottom: 1px solid var( --color-base200 );
  background-color: var( --color-base100 );
}
.pane_ajaBp.pane-rootEditorContent_MeX7r {
  border-bottom: 2px solid var( --color-base200 );
}
.pane_ajaBp.pane-editorDialog_g0A_m {
  border-radius: var( --size-small );
  background-color: var( --color-white );
}
.pane_ajaBp.pane-editor_NYR8U {
  padding: var( --size-padMedium ) var( --size-medium ) var( --size-medium );
}`, "",{"version":3,"sources":["webpack://./src/theme/Pane.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;AACA;EACE,+BAA+B;EAC/B,sCAAsC;AACxC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,oFAAoF;EACpF,sBAAsB;EACtB,yCAAyC;AAC3C;AACA;EACE,wCAAwC;EACxC,+BAA+B;EAC/B,oFAAoF;EACpF,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,2DAA2D;EAC3D,+CAA+C;AACjD;AACA;EACE,+BAA+B;EAC/B,sCAAsC;AACxC;AACA;EACE,+BAA+B;EAC/B,4CAA4C;EAC5C,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,+BAA+B;EAC/B,sCAAsC;AACxC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,oFAAoF;EACpF,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,0CAA0C;EAC1C,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,6CAA6C;AAC/C;AACA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,+BAA+B;EAC/B,+CAA+C;EAC/C,mCAAmC;EACnC,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,sCAAsC;AACxC;AACA;EACE,uDAAuD;EACvD,sCAAsC;EACtC,8CAA8C;EAC9C,+CAA+C;AACjD;AACA;EACE,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,wCAAwC;AAC1C;AACA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;AACrB;AACA;EACE,+BAA+B;EAC/B,wCAAwC;AAC1C;AACA;EACE,+BAA+B;EAC/B,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;AAC1C;AACA;EACE,+CAA+C;AACjD;AACA;EACE,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,+BAA+B;EAC/B,+CAA+C;AACjD;AACA;EACE,YAAY;EACZ,+CAA+C;EAC/C,qCAAqC;EACrC,sCAAsC;EACtC,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,2EAA2E;EAC3E,UAAU;EACV,+CAA+C;EAC/C,gBAAgB;AAClB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,uCAAuC;AACzC;AACA;EACE,8CAA8C;AAChD;AACA;EACE,gCAAgC;EAChC,+CAA+C;EAC/C,wCAAwC;AAC1C;AACA;EACE,+CAA+C;AACjD;AACA;EACE,kCAAkC;EAClC,sCAAsC;AACxC;AACA;EACE,0EAA0E;AAC5E","sourcesContent":[".pane {\n  transition: box-shadow 0.2s;\n}\n.pane.pane-overlay {\n  padding: var( --size-padLarge );\n  background-color: var( --color-white );\n}\n.pane.pane-overlay:hover {\n  box-shadow: none;\n}\n.pane.pane-navHeader {\n  border: none;\n  box-shadow: 0 8px 16px var( --color-shadowBase ),0 0px 1px var( --color-shadowBase );\n  transition: width 0.4s;\n  background-color: var( --color-brand800 );\n}\n.pane.pane-loginPane {\n  border: 1px solid var( --color-base100 );\n  padding: var( --size-padLarge );\n  box-shadow: 0 8px 16px var( --color-shadowBase ),0 0px 1px var( --color-shadowBase );\n  border-radius: 8px;\n  background-color: var( --color-white );\n}\n.pane.pane-contentSection {\n  padding: 56px;\n  background-color: transparent;\n  border-top-width: 0px;\n  border-left-width: 0px;\n  border-right-width: 0px;\n  border-bottom-width: 0px;\n}\n.pane.pane-contentSection.pane-contentBorder {\n  padding: var( --size-padLarge ) var( --size-padLarge ) 24px;\n  border-bottom: 1px solid var( --color-base200 );\n}\n.pane.pane-formHeader {\n  padding: var( --size-padLarge );\n  background-color: var( --color-white );\n}\n.pane.pane-formBody {\n  padding: var( --size-padLarge );\n  border-top: 1px solid var( --color-base050 );\n  border-left: none;\n  border-right: none;\n  border-bottom: none;\n  background-color: var( --color-base050 );\n}\n.pane.pane-dialogHeader {\n  padding: var( --size-padLarge );\n}\n.pane.pane-dialogBody {\n  width: 432px;\n  padding: var( --size-padLarge );\n  background-color: var( --color-white );\n}\n.pane.pane-dialogFooter {\n  padding: var( --size-padLarge );\n}\n.pane.pane-dialog {\n  box-shadow: 0 8px 16px var( --color-shadowBase ),0 0px 1px var( --color-shadowBase );\n  max-height: 80vh;\n  border-radius: 8px;\n  background-color: var( --color-white );\n}\n.pane.pane-loginWarning {\n  border: 1px solid var( --color-danger100 );\n  padding: var( --size-padMedium );\n  margin-top: 16px;\n  min-height: 0px;\n  border-radius: 4px;\n  margin-bottom: 0px;\n  background-color: var( --color-shadowDanger );\n}\n.pane.pane-formGeoshape {\n  padding: var( --size-padLarge );\n  border-radius: 4px;\n  background-color: var( --color-white );\n}\n.pane.pane-contentSection.pane-contentSectionWhite {\n  padding: 56px;\n  background-color: var( --color-white );\n}\n.pane.pane-card {\n  width: 100%;\n  padding: var( --size-padLarge );\n  box-shadow: 0 1px 3px var( --color-shadowBase );\n  border-radius: var( --size-medium );\n  background-color: var( --color-white );\n}\n.pane.pane-mobileTabPortal {\n  height: 100%;\n  background-color: var( --color-white );\n}\n.pane.pane-mobileActions {\n  padding: var( --size-padXLarge ) var( --size-padLarge );\n  background-color: var( --color-white );\n  border-top-left-radius: var( --size-padLarge );\n  border-top-right-radius: var( --size-padLarge );\n}\n.pane.pane-mobileTabsHeader {\n  padding: var( --size-padLarge );\n}\n.pane.pane-mobileList {\n  height: 100%;\n  background-color: var( --color-base050 );\n}\n.pane.pane-mobileMapToggle {\n  margin-left: var( --size-padMedium );\n  padding-left: 12px;\n  margin-right: var( --size-padMedium );\n  padding-right: 40px;\n}\n.pane.pane-mobileItemHeader {\n  padding: var( --size-padLarge );\n  background-color: var( --color-base050 );\n}\n.pane.pane-mobileItemBody {\n  padding: var( --size-padLarge );\n  background-color: var( --color-white );\n}\n.pane.pane-mobileList.pane-mobileListSettings {\n  width: 100%;\n  height: 100%;\n  background-color: var( --color-base050 );\n}\n.pane.pane-mobileTabsHeader.pane-mobileDtrHeader {\n  box-shadow: 0 1px 3px var( --color-shadowBase );\n}\n.pane.pane-mobileDtrContent {\n  padding: var( --size-padLarge );\n}\n.pane.pane-sidebar {\n  height: 100%;\n  padding: var( --size-padLarge );\n  box-shadow: 0 1px 3px var( --color-shadowBase );\n}\n.pane.pane-tablePagination {\n  height: 64px;\n  box-shadow: 0 1px 3px var( --color-shadowBase );\n  padding-left: var( --size-padMedium );\n  padding-right: var( --size-padMedium );\n  background-color: var( --color-white );\n}\n.pane.pane-editPageSizeOverlay {\n  width: 100vw;\n  padding: var( --size-padLarge );\n  max-width: 412px;\n}\n.pane.pane-rootHeader {\n  padding: var( --size-padMedium ) var( --size-padLarge ) var( --size-pad12 );\n  z-index: 2;\n  box-shadow: 0 1px 3px var( --color-shadowBase );\n  min-height: 64px;\n}\n.pane.pane-dataCard {\n  padding: var( --size-padLarge );\n}\n.pane.pane-card.pane-graphContainer {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n.pane.pane-dialogHeader.pane-detailHeader {\n  padding-top: var( --size-padMedium );\n  padding-bottom: var( --size-padMedium );\n}\n.pane.pane-collectionEditorListSection {\n  border-right: 3px solid var( --color-base200 );\n}\n.pane.pane-collectionEditorSelectionHeader {\n  padding: var( --size-padMedium );\n  border-bottom: 1px solid var( --color-base200 );\n  background-color: var( --color-base100 );\n}\n.pane.pane-rootEditorContent {\n  border-bottom: 2px solid var( --color-base200 );\n}\n.pane.pane-editorDialog {\n  border-radius: var( --size-small );\n  background-color: var( --color-white );\n}\n.pane.pane-editor {\n  padding: var( --size-padMedium ) var( --size-medium ) var( --size-medium );\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pane": `pane_ajaBp`,
	"pane-overlay": `pane-overlay_vxudj`,
	"pane-navHeader": `pane-navHeader_wiqfL`,
	"pane-loginPane": `pane-loginPane_kl1fh`,
	"pane-contentSection": `pane-contentSection_MJg2_`,
	"pane-contentBorder": `pane-contentBorder_e5jpf`,
	"pane-formHeader": `pane-formHeader_VXjDE`,
	"pane-formBody": `pane-formBody_o6CCf`,
	"pane-dialogHeader": `pane-dialogHeader_kCcQX`,
	"pane-dialogBody": `pane-dialogBody_oizj4`,
	"pane-dialogFooter": `pane-dialogFooter_tP60i`,
	"pane-dialog": `pane-dialog_FXK8m`,
	"pane-loginWarning": `pane-loginWarning_zCQxl`,
	"pane-formGeoshape": `pane-formGeoshape_pnmYI`,
	"pane-contentSectionWhite": `pane-contentSectionWhite_djC5_`,
	"pane-card": `pane-card_kwSo4`,
	"pane-mobileTabPortal": `pane-mobileTabPortal_DwbOX`,
	"pane-mobileActions": `pane-mobileActions_k1Y4_`,
	"pane-mobileTabsHeader": `pane-mobileTabsHeader_rYSYY`,
	"pane-mobileList": `pane-mobileList_PBdHb`,
	"pane-mobileMapToggle": `pane-mobileMapToggle_pGDYP`,
	"pane-mobileItemHeader": `pane-mobileItemHeader_svJKE`,
	"pane-mobileItemBody": `pane-mobileItemBody_ePfFL`,
	"pane-mobileListSettings": `pane-mobileListSettings_RbkVN`,
	"pane-mobileDtrHeader": `pane-mobileDtrHeader_oFmAy`,
	"pane-mobileDtrContent": `pane-mobileDtrContent_ZPAWi`,
	"pane-sidebar": `pane-sidebar_Ipg9R`,
	"pane-tablePagination": `pane-tablePagination_eESLq`,
	"pane-editPageSizeOverlay": `pane-editPageSizeOverlay_y0Xjn`,
	"pane-rootHeader": `pane-rootHeader_bTPov`,
	"pane-dataCard": `pane-dataCard_kDUPJ`,
	"pane-graphContainer": `pane-graphContainer_Df06r`,
	"pane-detailHeader": `pane-detailHeader_jBddk`,
	"pane-collectionEditorListSection": `pane-collectionEditorListSection_g6tci`,
	"pane-collectionEditorSelectionHeader": `pane-collectionEditorSelectionHeader_gciiA`,
	"pane-rootEditorContent": `pane-rootEditorContent_MeX7r`,
	"pane-editorDialog": `pane-editorDialog_g0A_m`,
	"pane-editor": `pane-editor_NYR8U`
};
export default ___CSS_LOADER_EXPORT___;
